/**
 * ==========================================================================
 * BAGSANDGO CITY SWITCHER - SISTEMA CENTRALIZADO DE CIUDADES
 * ==========================================================================
 * 
 * Gestión unificada de cambio de ciudad:
 * - Cookies para persistencia (PHP puede leerlas)
 * - Eventos globales para sincronización
 * - Sin recargas de página en la home
 * 
 * @package BagsAndGo
 * @version 1.0.0
 */

(function() {
    'use strict';

    // ==========================================================================
    // CONFIGURACIÓN
    // ==========================================================================
    
    const CONFIG = {
        COOKIE_NAME: 'bagsandgo_city',
        COOKIE_DAYS: 30,
        VALID_CITIES: ['barcelona', 'valencia'],
        DEFAULT_CITY: 'barcelona',
        EVENT_NAME: 'bagsandgo:cityChanged',
        DEBUG: false
    };

    // ==========================================================================
    // CITY SWITCHER GLOBAL
    // ==========================================================================
    
    window.BagsAndGoCitySwitcher = {
        currentCity: null,
        callbacks: [],
        
        /**
         * Inicializa el sistema de ciudades
         */
        init: function() {
            this.currentCity = this.getCity();
            this.log('Inicializado con ciudad:', this.currentCity);
            return this;
        },
        
        /**
         * Obtiene la ciudad actual (de cookie o default)
         */
        getCity: function() {
            const cookieCity = this.getCookie(CONFIG.COOKIE_NAME);
            if (cookieCity && CONFIG.VALID_CITIES.includes(cookieCity)) {
                return cookieCity;
            }
            return CONFIG.DEFAULT_CITY;
        },
        
        /**
         * Cambia la ciudad activa
         * @param {string} city - Slug de la ciudad
         * @param {Object} options - { skipEvent: false, skipCookie: false }
         */
        setCity: function(city, options = {}) {
            // Validar
            if (!CONFIG.VALID_CITIES.includes(city)) {
                console.warn('[CitySwitcher] Ciudad inválida:', city);
                return false;
            }
            
            // Si es la misma, no hacer nada
            if (city === this.currentCity && !options.force) {
                this.log('Ciudad ya activa:', city);
                return false;
            }
            
            const previousCity = this.currentCity;
            this.currentCity = city;
            
            // Guardar en cookie
            if (!options.skipCookie) {
                this.setCookie(CONFIG.COOKIE_NAME, city, CONFIG.COOKIE_DAYS);
            }
            
            // También actualizar localStorage para compatibilidad
            try {
                localStorage.setItem('bagsandgo_selected_city', city);
            } catch (e) {
                // localStorage no disponible
            }
            
            // Disparar evento global
            if (!options.skipEvent) {
                const event = new CustomEvent(CONFIG.EVENT_NAME, {
                    detail: { 
                        city: city,
                        previousCity: previousCity,
                        source: options.source || 'unknown'
                    },
                    bubbles: true
                });
                document.dispatchEvent(event);
            }
            
            // Ejecutar callbacks registrados
            this.callbacks.forEach(callback => {
                try {
                    callback(city, previousCity);
                } catch (e) {
                    console.error('[CitySwitcher] Error en callback:', e);
                }
            });
            
            this.log('Ciudad cambiada:', previousCity, '→', city);
            return true;
        },
        
        /**
         * Registra un callback para cambios de ciudad
         */
        onChange: function(callback) {
            if (typeof callback === 'function') {
                this.callbacks.push(callback);
            }
            return this;
        },
        
        /**
         * Obtiene el nombre formateado de una ciudad
         */
        getCityName: function(city) {
            const names = {
                'barcelona': 'Barcelona',
                'valencia': 'Valencia',
                'madrid': 'Madrid'
            };
            return names[city] || city.charAt(0).toUpperCase() + city.slice(1);
        },
        
        /**
         * Verifica si una ciudad es válida
         */
        isValidCity: function(city) {
            return CONFIG.VALID_CITIES.includes(city);
        },
        
        // =======================================================================
        // UTILIDADES DE COOKIES
        // =======================================================================
        
        setCookie: function(name, value, days) {
            let expires = '';
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
        },
        
        getCookie: function(name) {
            const nameEQ = name + '=';
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(nameEQ) === 0) {
                    return decodeURIComponent(c.substring(nameEQ.length));
                }
            }
            return null;
        },
        
        deleteCookie: function(name) {
            document.cookie = name + '=; Max-Age=-99999999; path=/';
        },
        
        // =======================================================================
        // DEBUG
        // =======================================================================
        
        log: function(...args) {
            if (CONFIG.DEBUG) {
                console.log('[CitySwitcher]', ...args);
            }
        },
        
        enableDebug: function() {
            CONFIG.DEBUG = true;
            return this;
        }
    };

    // ==========================================================================
    // AUTO-INICIALIZACIÓN
    // ==========================================================================
    
    // Inicializar cuando DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            window.BagsAndGoCitySwitcher.init();
        });
    } else {
        window.BagsAndGoCitySwitcher.init();
    }

})();
